export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11384.0f0683e2.jpg";